import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import {
  useGetAnnexeUploads,
  useGetAnnexeUploadProgress,
} from "#/lib/api/annexe-upload";
import { PaginatedSearchSchema } from "#/lib/schemas/paginated-search";
import { AnnexeUploadsPage } from "#/components/pages/annexe-uploads/annexe-uploads-page";
import { useLegacyBackendUrl } from "#/hooks/use-legacy-url";

export const Route = createFileRoute("/$tenantCode/$market/annexe-uploads")({
  beforeLoad: () => ({ getTitle: () => m["resources.annexeUpload.name"]() }),
  validateSearch: PaginatedSearchSchema,
  component: AnnexeUploadsRoute,
});

function AnnexeUploadsRoute() {
  const { page, perPage } = Route.useSearch();
  const legacyBackendUrl = useLegacyBackendUrl();

  const { data, isLoading } = useGetAnnexeUploads({
    page,
    perPage,
    dateUpload: new Date().toISOString().split("T")[0],
  });
  const { progressData } = useGetAnnexeUploadProgress();

  const backendFilesUrl =
    legacyBackendUrl !== "" ? `${legacyBackendUrl}/tmp` : "";

  const uploads = data?.member ?? [];
  const totalItems = data?.totalItems ?? 0;
  const pageCount = Math.ceil(totalItems / perPage);

  return (
    <AnnexeUploadsPage
      uploads={uploads}
      pageCount={pageCount}
      progressData={progressData}
      isLoading={isLoading}
      backendFilesUrl={backendFilesUrl !== "" ? backendFilesUrl : undefined}
    />
  );
}
